import Vue, { DirectiveOptions, VNodeDirective } from 'vue'; // 引入Vue类型
export const stampTransMS = function (countdown: any,status:any) {
    let date = '';
    let start = new Date().getTime();
    let end = countdown * 1000;
    if((end - start) > 0 ) {
        let time = end - start;
        let day = Math.floor(time / (1000*60*60*24));
        let hours = Math.floor(time/ (1000*60*60)%24);
        let minutes = Math.floor(time / (1000*60)%60);
        let seconds = Math.floor(time / 1000%60);
        if(status == 0){
            date =
                (hours > 0 ? hours>=10 ? `${hours}:` :`0${hours}:` : '') +
                (minutes >= 10 ?`${minutes}:` : `0${minutes}:`) +
                (seconds >= 10 ? `${seconds}` : `0${seconds}`);
        }else{
            date =
                (day > 0 ? day + '天' : '') +
                (hours > 0 ? hours>=10 ? `${hours}时` :`0${hours}时` : '') +
                (minutes >= 10 ?`${minutes}分` : `0${minutes}分`) +
                (seconds >= 10 ? `${seconds}秒` : `0${seconds}秒`);
        }
    } else {
        date = status == 0 ? '00:00' : '00天00时00分'
    }
    return date;
}

export const stampTrans = function (str: any) {
    let date = new Date(str * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
    return Y + M + D + ' ' + h + m
}

export const stampTransTime = function (str: any,format='YYYY-MM-DD HH:mm:ss') {
    let date = new Date(str * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let M2 = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + ''
    let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
    let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let h2 = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ''
    let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    let m2 = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ''
    let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    if(format == 'YYYY-MM-DD'){
        return Y + M + D
    }
    else if(format == 'MM-DD HH:mm'){
        return M2 +'月'+ D + '日' + h2 +':' + m2+''
    }
    else {
        return Y + M + D + ' ' + h + m + s
    }
}

export const stampTransDay = function (str: any) {
      let date = new Date(str * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
      return Y + M + D
}
export const stampTransMD = function (str: any) {
    let date = new Date(str * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
    return M + D
}
export const dateToDay= function(date:any){
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ''
      // let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      // let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      // let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
      return Y + M + D
}
/**
 * 计算两个时间戳之间的天数差（自动处理秒级/毫秒级时间戳）
 * @param {number} timestamp1 开始时间戳（秒或毫秒）
 * @param {number} timestamp2 结束时间戳（秒或毫秒）
 * @param {number} [format=86400000] 时间戳格式（默认为毫秒级时间戳）
 * @returns {number} 天数差（向下取整）
 */
export const calculateDaysBetween = function (timestamp1:number, timestamp2:number,format:number=86400000) {
    // 统一转换为毫秒级时间戳（处理秒级输入）
    const ms1 = timestamp1.toString().length === 10 ? timestamp1 * 1000 : timestamp1;
    const ms2 = timestamp2.toString().length === 10 ? timestamp2 * 1000 : timestamp2;

    // 计算时间差的绝对值（毫秒）
    const diffMs = Math.abs(ms2 - ms1);

    // 转换为天数（1天=86400000毫秒）
    return Math.ceil(diffMs / format);
}
/**
 * 计算时间戳与今天的天数差（基于本地时区）
 * @param {number} timestamp 输入的时间戳（秒或毫秒）
 * @returns {number} 相差天数（整数，正数表示未来，负数表示过去）
 */
export const getDaysDiffFromToday = function (timestamp:number) {
    // 统一转换为毫秒级时间戳（处理秒级输入）
    const msTimestamp = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;

    // 获取输入时间的「本地日期起点」（当天 00:00:00）
    const inputDate = new Date(msTimestamp);
    inputDate.setHours(0, 0, 0, 0); // 清空时分秒毫秒
    const inputStartOfDay = inputDate.getTime();

    // 获取今天的「本地日期起点」（当天 00:00:00）
    const today = new Date();
    today.setHours(0, 0, 0, 0); // 清空时分秒毫秒
    const todayStartOfDay = today.getTime();

    // 计算时间差（毫秒）并转换为天数
    const diffMs = todayStartOfDay - inputStartOfDay ;
     // 1天=86400000毫秒
    return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}

export const timeAgo = function (timestamp:number) {
    // 将字符串转换为Date对象
    const date = new Date(timestamp).getTime();
    // 计算时间差（毫秒）
    const now = Math.floor(new Date().getTime()/1000);
    const diff = now - date;
    // 计算不同的单位（秒、分钟、小时、天）
    const seconds = Math.floor(diff);
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60; // 计算剩余秒数
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const years = Math.floor(days / 365);

    if (years > 0) return `${years}年前`;
    if (days > 0) return `${days}天前`;
    if (hours > 0) return `${hours}小时前`;
    if (minutes > 0) {
        // 分钟数大于0时，显示“X分X秒前”（如果剩余秒数为0则只显示分钟）
        return remainingSeconds > 0
            ? `${minutes}分${remainingSeconds}秒前`
            : `${minutes}分钟前`;
    }
    return seconds+'秒前'; // 或者 '几秒前'，取决于你的具体需求和精度要求
}
// 工具方法：获取时间戳（移到指令外部）
// 工具方法：获取时间戳（调整参数类型兼容）
const getTimestamp = (value: any, arg?: number): number | null => {
    if (Array.isArray(value)) {
        // 如果是数组，根据 arg 索引取值（arg 为数字）
        return value[0] || (arg !== undefined ? value[arg] : null);
    }
    return typeof value === 'number' ? value : null;
};

// 工具方法：将 binding.arg（string | undefined）转换为 number | undefined
const parseArgToNumber = (arg: string | undefined): number | undefined => {
    if (arg === undefined) return undefined;
    const num = Number(arg);
    // 避免非数字字符串转换为 NaN
    return isNaN(num) ? undefined : num;
};

// 工具方法：判断值是否变化（移到指令外部）
const isValueChanged = (oldVal: any, newVal: any): boolean => {
    if (oldVal === newVal) return false;
    if (Array.isArray(oldVal) && Array.isArray(newVal)) {
        return JSON.stringify(oldVal) !== JSON.stringify(newVal);
    }
    return oldVal !== newVal;
};

// 注册全局时间指令（严格符合 DirectiveOptions 类型）
Vue.directive('time-ago', {
    bind(el: HTMLElement, binding: VNodeDirective) {
        let timer: number | null = null;

        const updateTime = () => {
            const timestamp = el.dataset.timestamp ? Number(el.dataset.timestamp) : null;
            if (timestamp) {
                el.textContent = timeAgo(timestamp);
            } else {
                el.textContent = '';
            }
        };

        // 初始化时间戳：将 binding.arg 转换为数字
        const initialValue = binding.value;
        const arg = parseArgToNumber(binding.arg); // 关键：转换 arg 为数字
        const timestamp = getTimestamp(initialValue, arg);
        if (timestamp) {
            el.dataset.timestamp = timestamp.toString();
        }
        updateTime();

        timer = window.setInterval(updateTime, 1000);
        el.dataset.timeTimer = timer.toString();
    },

    update(el: HTMLElement, binding: VNodeDirective) {
        if (isValueChanged(binding.oldValue, binding.value)) {
            const arg = parseArgToNumber(binding.arg); // 转换 arg 为数字
            const timestamp = getTimestamp(binding.value, arg);
            if (timestamp) {
                el.dataset.timestamp = timestamp.toString();
                el.textContent = timeAgo(timestamp);
            }
        }
    },

    componentUpdated(el: HTMLElement, binding: VNodeDirective) {
        const arg = parseArgToNumber(binding.arg); // 转换 arg 为数字
        const timestamp = getTimestamp(binding.value, arg);
        if (timestamp) {
            el.dataset.timestamp = timestamp.toString();
            el.textContent = timeAgo(timestamp);
        }
    },

    // unbind 钩子保持不变
    unbind(el: HTMLElement) {
        const timerId = el.dataset.timeTimer;
        if (timerId) clearInterval(Number(timerId));
        delete el.dataset.timeTimer;
        delete el.dataset.timestamp;
    }
} as DirectiveOptions);
